module.exports = __webpack_public_path__ + "img/big_eye.658495f8.gif";